export default __webpack_public_path__ + "static/Sulfur-37d37f5747dfe0e32094a80701a52a93.png";